import * as Actions from './appointment.actions';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel, EmptyCriteria } from 'src/app/shared/interfaces/CriteriaModel';
import { PaginatorModel } from 'src/app/shared/interfaces/PaginatorModel';

/*Defining the state shape*/
export interface State {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	CreateAppointment: {
		success: boolean;
		response: any | null;
	},
	getAppointments: {
		payload: CriteriaModel;
		response: any;
	},
	rescheduleAppointment: {
		success: boolean;
		response: any | null;
	},
}

/*Setting the initial state*/
export const initialState: State = {
	error: null,
	hasError: false,
	requestProcessing: false,
	CreateAppointment: {
		success: false,
		response: null,
	},
	getAppointments: {
		payload: EmptyCriteria,
		response: null
	},
	rescheduleAppointment: {
		success: false,
		response: null,
	},
};

/*Creating the reducer function*/
export function AppointmentReducer(
	state = initialState,
	action: Actions.Actions
): State {
	switch (action.type) {
		case Actions.ActionTypes.CreateAppointment: {
			return {
				...state,
				requestProcessing: true,
				CreateAppointment: {
					...state.CreateAppointment
				}
			};
		}
		case Actions.ActionTypes.CreateAppointmentSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				CreateAppointment: {
					...state.CreateAppointment,
					response: action.payload,
					success: true,
				}
			};
		}

		case Actions.ActionTypes.CreateAppointmentError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				CreateAppointment: {
					...state.CreateAppointment,
					response: null,
					success: false,
				}
			};
		}

		case Actions.ActionTypes.GetAppointments: {
			return {
				...state,
				requestProcessing: true,
				getAppointments: {
					...state.getAppointments,
					payload: action.payload,
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetAppointmentsSuccess: {
			return {
				...state,
				requestProcessing: false,
				getAppointments: {
					...state.getAppointments,
					response: action.payload
				}
			};
		}

		case Actions.ActionTypes.GetAppointmentsError: {
			return {
				...state,
				requestProcessing: false,
				getAppointments: {
					...state.getAppointments,
					response: null
				}
			};
		}

		case Actions.ActionTypes.RescheduleAppointment: {
			return {
				...state,
				requestProcessing: true,
				rescheduleAppointment: {
					...state.rescheduleAppointment
				}
			};
		}
		case Actions.ActionTypes.RescheduleAppointmentSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				rescheduleAppointment: {
					...state.rescheduleAppointment,
					response: action.payload,
					success: true,
				}
			};
		}
		case Actions.ActionTypes.RescheduleAppointmentError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				rescheduleAppointment: {
					...state.rescheduleAppointment,
					response: null,
					success: false,
				}
			};
		}

		case Actions.ActionTypes.CancelAppointment: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case Actions.ActionTypes.CancelAppointmentSuccess: {
			return {
				...state,
				requestProcessing: false,
			};
		}
		case Actions.ActionTypes.CancelAppointmentError: {
			return {
				...state,
				requestProcessing: false,
			};
		}


		default:
			return state;
	}
}
